import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { t } from '../i18n'

type ProgressStore = {
  currentStep: number
  routesNavigated: string[]
  stepsNavigated: number[]
  setCurrentStep: (currentStep: number) => void
  setStepsNavigated: (stepsNavigated: number) => void
  setRoutesNavigated: (routesNavigated: string) => void
  setAllRoutesNavigated: (routesNavigated: string[]) => void
}

export const useProgressStore = create<ProgressStore>()(
  devtools(
    (set) => ({
      currentStep: 1,
      stepsNavigated: [1],
      routesNavigated: [t('constants.routes.base')],
      setCurrentStep: (currentStep) => set({ currentStep }),
      setAllRoutesNavigated: (routesNavigated) => set({ routesNavigated }),
      setRoutesNavigated: (routesNavigated) => {
        return set((state) => {
          const newData = [
            ...state.routesNavigated,
            state.routesNavigated.includes(routesNavigated)
              ? ''
              : routesNavigated,
          ].filter(Boolean)

          return { routesNavigated: newData }
        })
      },
      setStepsNavigated: (stepsNavigated) => {
        return set((state) => {
          const newData = [
            ...state.stepsNavigated,
            state.stepsNavigated.includes(stepsNavigated) ? 0 : stepsNavigated,
          ].filter((item) => item > 0)

          return { stepsNavigated: newData }
        })
      },
    }),
    { name: 'ProgressStore' },
  ),
)
